module.exports = __webpack_public_path__ + "static/media/SaveIcon.504da469.svg";